document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.videoPlay');

  videos.forEach((video) => {
    const button = document.querySelector(`[aria-controls="${video.id}"]`);
    const playIcon = button.querySelector('[data-icon-play]');
    const pauseIcon = button.querySelector('[data-icon-pause]');

    // Ensure videos load paused
    video.preload = 'metadata';
    video.pause();
    video.currentTime = 0;

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        playIcon.hidden = true;
        pauseIcon.hidden = false;
      } else {
        video.pause();
        playIcon.hidden = false;
        pauseIcon.hidden = true;
      }
    });
  });
});
